<template>
	<v-container>
		<v-card :loading="loading" flat>
			<v-card-title>Definição de Usuários Avaliadores de Contrato</v-card-title>
			<v-card-text>
				<v-form @submit.prevent="addEvaluator">
					<v-row>
						<v-col cols="12" md="4">
							<v-select
								v-model="form.CODGRP"
								:items="groups"
								item-text="DESGRP"
								item-value="CODGRP"
								label="Grupo"
								class="required"
								clearable
								:loading="loadingGroup"
							></v-select>
						</v-col>
						<v-col cols="12" md="4">
							<v-select
								v-model="form.CODEMP"
								:items="companies"
								item-text="DESEMP"
								item-value="CODEMP"
								label="Empresa"
                class="required"
								:loading="loadingCompany"
								clearable
								@change="getUnits(true)"
							></v-select>
						</v-col>
						<v-col cols="12" md="4">
							<v-select
								v-model="form.CODUNI"
								:items="units"
								item-text="DESUNI"
								item-value="CODUNI"
								label="Unidade"
                class="required"
								:loading="loadingUnit"
								clearable
							></v-select>
						</v-col>
						<v-col cols="12" md="6">
							<v-select
								v-model="form.CODUSU"
								:items="users"
								item-text="NOMUSU"
								item-value="CODUSU"
								label="Usuário"
                class="required"
								:loading="loadingUser"
								clearable
							></v-select>
						</v-col>
						<v-col cols="12" md="6">
							<v-switch
								v-model="form.AVALIADOR"
								label="Avaliador de Contrato?"
							/>
						</v-col>
						<v-col cols="12" md="3">
							<v-btn depressed tile color="primary" @click="save" :disabled="loading"
								>{{ id ? "Salvar" : "Adicionar" }} Avaliador</v-btn
							>
						</v-col>
					</v-row>
				</v-form>
				<v-divider class="my-4" />
			</v-card-text>
		</v-card>
	</v-container>
</template>
<script>
import ContractEvaluatorsService from "@/app/Services/ContractEvaluatorsService";
import CompanyGroupService from "@/app/Services/CompanyGroupService";
import CompanyService from "@/app/Services/CompanyService";
import UnitService from "@/app/Services/UnitService";
import UserService from "@/app/Services/UserService";
import { toast } from "../../plugins/utils";

const contractEvaluatorsService = ContractEvaluatorsService.build();
const companyGroupService = CompanyGroupService.build();
const companyService = CompanyService.build();
const unitService = UnitService.build();
const userService = UserService.build();

export default {
	name: "ContractEvaluatorsForm",
	data() {
		return {
			evaluators: [],
			form: {
				CODGRP: "",
				CODEMP: "",
				CODUNI: "",
				CODUSU: "",
				AVALIADOR: false,
			},
      id: null,
      view: false,
			loading: false,
      loadingGroup: false,
      loadingCompany: false,
      loadingUnit: false,
      loadingUser: false,
			groups: [],
			companies: [],
			units: [],
			areas: [],
			users: [],
		};
	},
	mounted() {
		const { id, view } = this.$route.params;
		this.userData = JSON.parse(localStorage.getItem("user"));

		if (id) {
			this.id = id;
		}

		if (view) {
			this.view = view;
		}

		this.fetch();
	},
	methods: {
		async fetch() {
			Promise.all([
				this.getGroup(),
				this.getCompanies(),
				this.getUnits(),
				this.getUsers(),
        this.getEvaluator(),
			]);
		},
		save() {
      this.loading = true;  

      const rest = this.id ? contractEvaluatorsService.update({ id: this.id, ...this.form }) : contractEvaluatorsService.create({ ...this.form});

      rest.then(() => {
        this.toast("success", "Avaliador salvo com sucesso");
        this.$router.push("/contract-evaluator/list");
      }).catch(() => {
        this.toast("error", "Erro ao salvar avaliador");
      }).finally(() => {
        this.loading = false;
      });
		},
    getEvaluator() {
      if (!this.id) return;

      this.loading = true;
      
      contractEvaluatorsService.read(this.id).then((response) => {
        this.form = response;
        this.loading = false;
      });
    },
		getGroup() {
			this.loadingGroup = true;

			companyGroupService.search("").then((response) => {
				this.groups = response;
				this.loadingGroup = false;
			});
		},
		getCompanies() {
			this.loadingCompany = true;
			companyService.search({}).then((response) => {
				this.companies = response;
				this.loadingCompany = false;
			});
		},
		getUnits(change) {
			const search = {};

			this.units = [];
			this.areas = [];
			this.loadingUnit = true;

			if (change) {
				this.form.CODUNI = "";
			}

			if (this.form.CODEMP) {
				search.company = this.form.CODEMP;
			}

			unitService.search(search).then((response) => {
				this.units = response;
				this.loadingUnit = false;
			});
		},
		getUsers() {
			this.loadingUser = true;
			userService.usersByKey().then((response) => {
				this.users = response;
				this.loadingUser = false;
			});
		},
    toast
	},
};
</script>
